import { useBreadcrumb } from "features/breadcrumbs";
import Container from "components/Container";
import ListagemComposicaoReceitasHorizontal from "./components/ListagemComposicaoReceitasHorizontal";

function RelatorioComposicaoReceitasHorizontalPage() {
  useBreadcrumb([
    { name: "Relatórios" },
    { name: "Financeiro", url: "/relatorios/financeiro" },
    {
      name: "Relatório de receitas com composição horizontal",
      url: "/relatorios/financeiro/composicao-receitas-horizontal",
    },
  ]);

  return (
    <Container>
      <ListagemComposicaoReceitasHorizontal />
    </Container>
  );
}

export default RelatorioComposicaoReceitasHorizontalPage;
